/* global BX, jsAjaxUtil */

import {refreshBasketFly} from './basket-fly/refresh-basket-fly';
import {applyBasketState} from './basket-fly/set-state-user';

BX.namespace('BX.Sale.PersonalOrderComponent');

(function () {
    BX.Sale.PersonalOrderComponent.PersonalOrderDetail = {
        init: function (params) {
            var linkMoreOrderInformation = document.getElementsByClassName(
                'sale-order-detail-about-order-inner-container-name-read-more'
            )[0];
            var linkLessOrderInformation = document.getElementsByClassName(
                'sale-order-detail-about-order-inner-container-name-read-less'
            )[0];
            var clientInformation = document.getElementsByClassName(
                'sale-order-detail-about-order-inner-container-details'
            )[0];
            var listShipmentWrapper = document.getElementsByClassName('sale-order-detail-payment-options-shipment');
            var listPaymentWrapper = document.getElementsByClassName('sale-order-detail-payment-options-methods');
            var shipmentTrackingId = document.getElementsByClassName('sale-order-detail-shipment-id');

            if (shipmentTrackingId[0]) {
                Array.prototype.forEach.call(shipmentTrackingId, function (blockId) {
                    var clipboard = blockId.parentNode.getElementsByClassName('sale-order-detail-shipment-id-icon')[0];
                    if (clipboard) {
                        BX.clipboard.bindCopyClick(clipboard, {text: blockId.innerHTML});
                    }
                });
            }

            BX.bind(
                linkMoreOrderInformation,
                'click',
                function () {
                    clientInformation.style.display = 'inline-block';
                    linkMoreOrderInformation.style.display = 'none';
                    linkLessOrderInformation.style.display = 'inline-block';
                },
                this
            );
            BX.bind(
                linkLessOrderInformation,
                'click',
                function () {
                    clientInformation.style.display = 'none';
                    linkMoreOrderInformation.style.display = 'inline-block';
                    linkLessOrderInformation.style.display = 'none';
                },
                this
            );

            Array.prototype.forEach.call(listShipmentWrapper, function (shipmentWrapper) {
                var detailShipmentBlock = shipmentWrapper.getElementsByClassName(
                    'sale-order-detail-payment-options-shipment-composition-map'
                )[0];
                var showInformation = shipmentWrapper.getElementsByClassName('sale-order-detail-show-link')[0];
                var hideInformation = shipmentWrapper.getElementsByClassName('sale-order-detail-hide-link')[0];

                BX.bindDelegate(
                    shipmentWrapper,
                    'click',
                    {class: 'sale-order-detail-show-link'},
                    BX.proxy(function () {
                        showInformation.style.display = 'none';
                        hideInformation.style.display = 'inline-block';
                        detailShipmentBlock.style.display = 'block';
                    }, this)
                );
                BX.bindDelegate(
                    shipmentWrapper,
                    'click',
                    {class: 'sale-order-detail-hide-link'},
                    BX.proxy(function () {
                        showInformation.style.display = 'inline-block';
                        hideInformation.style.display = 'none';
                        detailShipmentBlock.style.display = 'none';
                    }, this)
                );
            });

            Array.prototype.forEach.call(listPaymentWrapper, function (paymentWrapper) {
                var rowPayment = paymentWrapper.getElementsByClassName(
                    'sale-order-detail-payment-options-methods-info'
                )[0];

                BX.bindDelegate(
                    paymentWrapper,
                    'click',
                    {class: 'active-button'},
                    BX.proxy(function () {
                        BX.toggleClass(paymentWrapper, 'sale-order-detail-active-event');
                    }, this)
                );

                BX.bindDelegate(
                    rowPayment,
                    'click',
                    {class: 'sale-order-detail-payment-options-methods-info-change-link'},
                    BX.proxy(function (event) {
                        event.preventDefault();

                        var btn = rowPayment.parentNode.getElementsByClassName(
                            'sale-order-detail-payment-options-methods-button-container'
                        )[0];
                        var linkReturn = rowPayment.parentNode.getElementsByClassName(
                            'sale-order-detail-payment-inner-row-template'
                        )[0];
                        BX.ajax(
                            {
                                method: 'POST',
                                dataType: 'html',
                                url: params.url,
                                data: {
                                    sessid: BX.bitrix_sessid(),
                                    orderData: params.paymentList[event.target.id],
                                    templateName: params.templateName,
                                },
                                onsuccess: BX.proxy(function (result) {
                                    rowPayment.innerHTML = result;
                                    if (btn) {
                                        btn.parentNode.removeChild(btn);
                                    }
                                    linkReturn.style.display = 'block';
                                    BX.bind(
                                        linkReturn,
                                        'click',
                                        function () {
                                            window.location.reload();
                                        },
                                        this
                                    );
                                }, this),
                                onfailure: BX.proxy(function () {
                                    return this;
                                }, this),
                            },
                            this
                        );
                    }, this)
                );
            });
        },
    };
})();

function markProductToBasket(element) {
    const toCartTitle = element.querySelector('span');
    toCartTitle.textContent = 'В корзине';
    element.classList.add('in-basket');
}

function openBasketFly() {
    const basket = document.querySelector('#basket_line .basket_fly, .basket_fly.basket-fly');

    if (!basket) {
        return;
    }

    basket.classList.add('basket-fly--opened');
    basket.classList.remove('basket-fly--closed');
    basket.setAttribute('aria-hidden', 'false');
    applyBasketState(basket, 'AnDelCanBuy');
}

const activeCompareSvg =
    '<svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="34" height="34" rx="17" fill="#2059B0"/><path d="M12.92 22.4399L12.92 11.5599M17 22.4399L17 15.6399M21.08 22.4399L21.08 19.7199" stroke="white" stroke-width="1.36" stroke-linecap="round" stroke-linejoin="round"/></svg>';

function getCompareButtonElement(element) {
    return element.querySelector('.catalog-card__compare') || element;
}

function storeOriginalCompareSvg(element) {
    if (!element.originalSvgStored) {
        const svgElement = element.querySelector('svg');
        if (svgElement) {
            element.originalSvg = svgElement.outerHTML;
            element.originalSvgStored = true;
        }
    }
}

function setCompareActive(element, isActive) {
    storeOriginalCompareSvg(element);

    if (isActive) {
        element.classList.add('active');
        element.innerHTML = activeCompareSvg;
    } else {
        element.classList.remove('active');
        if (element.originalSvg) {
            element.innerHTML = element.originalSvg;
        }
    }
}

document.addEventListener('DOMContentLoaded', () => {
    const viewMoreButtons = document.querySelectorAll('.cp_orders__more');
    viewMoreButtons.forEach((button) => {
        button.addEventListener('click', () => {
            const order = button.closest('.cp_orders__item');
            const productsList = order ? order.querySelector('.cp_orders__item-products') : null;

            button.classList.toggle('cp_orders__more--active');
            if (productsList) {
                productsList.classList.toggle('cp_orders__item-products_active');
            }
        });
    });

    const products = document.querySelectorAll('.cp_orders__item-product');

    function markProductsToBasket(productId) {
        products.forEach((product) => {
            const toCart = product.querySelector('.cp_orders__item-product__controls-cart');

            if (toCart && toCart.dataset.item === productId) {
                markProductToBasket(toCart);
            }
        });
    }

    function markProductsToCompare(productId) {
        products.forEach((product) => {
            const toCart = product.querySelector('.cp_orders__item-product__controls-cart');
            const toCompare = product.querySelector('.cp_orders__item-product__controls-compare');

            if (toCart && toCompare && toCart.dataset.item === productId) {
                setCompareActive(getCompareButtonElement(toCompare), true);
            }
        });
    }

    function syncCompareButtons() {
        if (!window.CatalogCardState) {
            return;
        }

        products.forEach((product) => {
            const toCart = product.querySelector('.cp_orders__item-product__controls-cart');
            const toCompare = product.querySelector('.cp_orders__item-product__controls-compare');

            if (!toCart || !toCompare) {
                return;
            }

            const productId = toCart.dataset.item;
            const compareButton = getCompareButtonElement(toCompare);
            setCompareActive(compareButton, productId in window.CatalogCardState.compare);
        });
    }

    products.forEach((product) => {
        const toCart = product.querySelector('.cp_orders__item-product__controls-cart');

        if (!toCart) {
            return;
        }

        const productId = toCart.dataset.item;

        fetch(`/api/v1/basket/item/${productId}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Session-Id': BX.bitrix_sessid(),
            },
        })
            .then((res) => res.json())
            .then(function (result) {
                if (result.isProductFromBasket) {
                    markProductsToBasket(productId);
                }
            })
            .catch((err) => console.error(err));

        toCart.addEventListener('click', (event) => {
            event.preventDefault();

            fetch('/api/v1/basket', {
                method: 'POST',
                body: JSON.stringify({
                    productId: productId,
                }),
                headers: {
                    'Content-Type': 'application/json',
                    'Session-Id': BX.bitrix_sessid(),
                },
            })
                .then((res) => res.json())
                .then(async function (result) {
                    if (result.success === false) {
                        return;
                    }

                    try {
                        await refreshBasketFly();
                        openBasketFly();
                    } catch (err) {
                        console.error(err);
                    }

                    markProductsToBasket(productId);
                    BX.onCustomEvent('onCompleteAction', [{action: 'loadBasket'}]);
                })
                .catch((err) => console.error(err));
        });

        const toCompare = product.querySelector('.cp_orders__item-product__controls-compare');

        if (!toCompare) {
            return;
        }

        toCompare.addEventListener('click', (event) => {
            event.preventDefault();

            fetch('/api/v1/compare', {
                method: 'POST',
                body: JSON.stringify({
                    productId: productId,
                }),
                headers: {
                    'Content-Type': 'application/json',
                    'Session-Id': BX.bitrix_sessid(),
                },
            })
                .then((res) => res.json())
                .then(function (result) {
                    if (result.success === false) {
                        return;
                    }

                    jsAjaxUtil.InsertDataToNode('/ajax/show_compare_preview_fly.php', 'compare_fly', false);
                    markProductsToCompare(productId);
                    BX.onCustomEvent('onCompleteAction', [{action: 'loadBasket'}]);
                })
                .catch((err) => console.error(err));
        });
    });

    if (window.CatalogCardState) {
        window.CatalogCardState.onReady(syncCompareButtons);
        window.CatalogCardState.addUpdateListener(syncCompareButtons);
    }
});
